import { useState, useEffect, useRef } from "react";

/**
 * Manages the AHT (Average Handle Time) timer for call center calls.
 * Handles start, stop, pause (hold), and resume of the timer.
 *
 * @param {Object} params
 * @param {boolean} params.callCenterVisible - Whether the call center is active
 * @returns {{ ahtSeconds: number, setAhtSeconds: Function, timerRef: React.MutableRefObject, formatAHT: Function }}
 */
const useCallCenterTimer = ({ callCenterVisible }) => {
  const [ahtSeconds, setAhtSeconds] = useState(0);
  const timerRef = useRef(null);

  // Start AHT timer when Call Center page is opened
  // AHT Timer: Reset & Start when call is active
  useEffect(() => {
    if (callCenterVisible) {
      setAhtSeconds(0); // Reset to 0
      timerRef.current = setInterval(() => {
        setAhtSeconds((prev) => prev + 1);
      }, 1000);
    }

    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
        timerRef.current = null;
      }
    };
  }, [callCenterVisible]); // ← Restart when call resumes

  const formatAHT = (totalSeconds) => {
    const mins = String(Math.floor(totalSeconds / 60)).padStart(2, "0");
    const secs = String(totalSeconds % 60).padStart(2, "0");
    return `${mins}:${secs}`;
  };

  return {
    ahtSeconds,
    setAhtSeconds,
    timerRef,
    formatAHT,
  };
};

export default useCallCenterTimer;
